// Each division = one full-viewport chapter.
// accent = signature palette (used for underline / logo halo / index / selection).
export const DIVISIONS = [
  {
    slug: "print",
    index: "01",
    name: "2TPrint",
    kicker: { en: "COMMERCIAL PRINT / LARGE FORMAT", fr: "IMPRESSION COMMERCIALE / GRAND FORMAT" },
    tagline: {
      en: "Ink meets intention.",
      fr: "L'encre rencontre l'intention.",
    },
    body: {
      en: "From business cards to rollup banners, real estate signs, brochures, books, labels and apparel — a full-scale print house obsessed with color fidelity and finish.",
      fr: "Des cartes de visite aux bannières roll-up, panneaux immobiliers, brochures, livres, étiquettes et vêtements — une imprimerie complète obsédée par la fidélité des couleurs et la finition.",
    },
    services: {
      en: ["Business Cards", "Brochures & Books", "Real Estate Signs", "Rollup Banners", "Labels", "Large Format"],
      fr: ["Cartes de visite", "Brochures & Livres", "Panneaux immobiliers", "Bannières Roll-up", "Étiquettes", "Grand Format"],
    },
    logo: "https://customer-assets.emergentagent.com/job_58d79254-d3a3-44c1-a189-6d1fd7fde1f0/artifacts/icwx2g2w_2T_Print.png",
    video: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/w18ey0w5_2TPrint_CMYK_Commercial_Print__Gemini_Omni_Flash_66405.mp4",
    image: "https://images.unsplash.com/photo-1616696269349-2d8821da8c2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxwcmludCUyMHNob3AlMjBicm9jaHVyZXN8ZW58MHx8fHwxNzg0MDM4MTIyfDA&ixlib=rb-4.1.0&q=85",
    accent: "#22d3ee",
    accentSoft: "rgba(34,211,238,0.18)",
  },
  {
    slug: "shirt",
    index: "02",
    name: "2TShirt",
    kicker: { en: "CUSTOM APPAREL — E-COMMERCE", fr: "VÊTEMENTS PERSONNALISÉS — E-COMMERCE" },
    tagline: {
      en: "Wear the studio.",
      fr: "Porte le studio.",
    },
    body: {
      en: "Custom print apparel dropped straight to your door — DTG, DTF, screen-print & embroidery. Cotton that speaks louder than a slogan.",
      fr: "Vêtements personnalisés livrés directement chez toi — DTG, DTF, sérigraphie & broderie. Du coton qui parle plus fort qu'un slogan.",
    },
    services: {
      en: ["DTG Printing", "DTF Transfers", "Screen Print", "Embroidery", "Tags & Packaging", "Small Runs"],
      fr: ["Impression DTG", "Transferts DTF", "Sérigraphie", "Broderie", "Étiquettes", "Petites séries"],
    },
    logo: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/5zch7094_2TSHIRT_TR.webp", // 2TShirt transparent logo
    video: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/gew9au0z_Slow_orbital_camera_around_a_p_Gemini_Omni_Flash_57704.mp4",
    image: "https://images.unsplash.com/photo-1663433567177-9f94be0bff4c?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85&auto=format&ixlib=rb-4.1.0",
    accent: "#f472b6",
    accentSoft: "rgba(244,114,182,0.18)",
  },
  {
    slug: "sticker",
    index: "03",
    name: "2TSticker",
    kicker: { en: "CUSTOM STICKERS — E-COMMERCE", fr: "STICKERS PERSONNALISÉS — E-COMMERCE" },
    tagline: {
      en: "Stick loud. Stick everywhere.",
      fr: "Colle fort. Colle partout.",
    },
    body: {
      en: "Die-cut, kiss-cut, holographic, transparent, weatherproof. Whatever surface you own, we own the adhesive that makes it yours.",
      fr: "Découpe à la forme, kiss-cut, holographique, transparent, résistant. Peu importe la surface, on a l'adhésif qui la rend tienne.",
    },
    services: {
      en: ["Die-Cut", "Kiss-Cut", "Holographic", "Transparent", "Weatherproof", "Sticker Sheets"],
      fr: ["Découpe forme", "Kiss-Cut", "Holographique", "Transparent", "Anti-intempéries", "Planches"],
    },
    logo: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/sq0ffz61_2TSTICKER_TR.webp",
    video: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/rf4tl1bv_2TSticker_Rainbow_Iridescent_C_Gemini_Omni_Flash_43456.mp4",
    image: "https://images.unsplash.com/photo-1668419912281-800c50f17cda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxjb2xvcmZ1bCUyMGRpZSUyMGN1dCUyMHN0aWNrZXJzJTIwZmxhdGxheXxlbnwwfHx8fDE3ODQwMzgxMjF8MA&ixlib=rb-4.1.0&q=85",
    accent: "#a78bfa",
    accentSoft: "rgba(167,139,250,0.20)",
  },
  {
    slug: "deco",
    index: "04",
    name: "2TDeco",
    kicker: { en: "WALL ART — 25 000 PIECES", fr: "ART MURAL — 25 000 PIÈCES" },
    tagline: {
      en: "Rooms that remember you.",
      fr: "Des pièces qui se souviennent de toi.",
    },
    body: {
      en: "Twenty-five thousand curated art pieces printed on canvas, acrylic, aluminum, museum paper. Interior design elevated to gallery weight.",
      fr: "Vingt-cinq mille œuvres sélectionnées, imprimées sur toile, acrylique, aluminium, papier musée. Le design intérieur au poids d'une galerie.",
    },
    services: {
      en: ["Canvas Prints", "Acrylic Glass", "Metal Prints", "Museum Paper", "Custom Framing", "Trade & Hospitality"],
      fr: ["Toile", "Verre acrylique", "Métal", "Papier musée", "Encadrement", "Pro & Hôtellerie"],
    },
    logo: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/g0nuev9d_2TDECO-TR.webp",
    video: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/v21lfsot_2TDeco_Gold_Wall_Art_25_000_pi_Gemini_Omni_Flash_98575.mp4",
    image: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxmcmFtZWQlMjBjYW52YXMlMjB3YWxsJTIwYXJ0JTIwZ2FsbGVyeXxlbnwwfHx8fDE3ODQwMzgxMjJ8MA&ixlib=rb-4.1.0&q=85",
    accent: "#f5c542",
    accentSoft: "rgba(245,197,66,0.18)",
  },
  {
    slug: "pack",
    index: "05",
    name: "2TPack",
    kicker: { en: "CUSTOM PACKAGING — E-COMMERCE", fr: "EMBALLAGE PERSONNALISÉ — E-COMMERCE" },
    tagline: {
      en: "The first thing they touch.",
      fr: "La première chose qu'ils touchent.",
    },
    body: {
      en: "Rigid boxes, mailers, tissue, custom tape, sleeves. Unboxing engineered into a brand moment — sustainable, dielined, dead-on.",
      fr: "Boîtes rigides, pochettes, papier de soie, ruban personnalisé, fourreaux. Le déballage devient un moment de marque — durable, précis, imparable.",
    },
    services: {
      en: ["Rigid Boxes", "Mailers", "Tissue Paper", "Custom Tape", "Sleeves", "Sustainable Materials"],
      fr: ["Boîtes rigides", "Pochettes", "Papier de soie", "Ruban", "Fourreaux", "Matériaux durables"],
    },
    logo: "https://customer-assets.emergentagent.com/job_58d79254-d3a3-44c1-a189-6d1fd7fde1f0/artifacts/fc52wpni_2T_Pack.png",
    video: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/p2trfrb9_2TPack_Green_Blue_Custom_Packa_Gemini_Omni_Flash_25071.mp4",
    image: "https://images.unsplash.com/photo-1595246007497-15e0ed4b8d96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjdXN0b20lMjBwYWNrYWdpbmclMjBib3hlc3xlbnwwfHx8fDE3ODQwMzgxMjJ8MA&ixlib=rb-4.1.0&q=85",
    accent: "#4ade80",
    accentSoft: "rgba(74,222,128,0.18)",
    logoClass: "h-52 md:h-72 lg:h-[22rem]",
  },
  {
    slug: "wrap",
    index: "06",
    name: "2TWrap",
    kicker: { en: "HIGH-END CAR WRAP STUDIO", fr: "STUDIO DE COVERING HAUT DE GAMME" },
    tagline: {
      en: "Skin your machine.",
      fr: "Habille ta machine.",
    },
    body: {
      en: "Vehicle branding, full color-change wraps, paint protection film and windshield film — installed with the patience of a couturier.",
      fr: "Habillage de véhicules, covering complet, film de protection carrosserie et pare-brise — posés avec la patience d'un couturier.",
    },
    services: {
      en: ["Color Change Wrap", "Vehicle Branding", "Paint Protection Film", "Windshield Film", "Chrome Delete", "Fleet Programs"],
      fr: ["Covering complet", "Branding véhicule", "Film protection", "Film pare-brise", "Chrome delete", "Programmes flotte"],
    },
    logo: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/6ii7iae4_2TWRAP_TR.webp",
    video: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/thp3rfdr_2TWrap_Cyan_Magenta_Purple_Car_Gemini_Omni_Flash_48807.mp4",
    image: "https://images.unsplash.com/photo-1668994597645-a3729951b7ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxzdXBlcmNhciUyMHZpbnlsJTIwd3JhcCUyMGRldGFpbHxlbnwwfHx8fDE3ODQwMzgxMjJ8MA&ixlib=rb-4.1.0&q=85",
    accent: "#22d3ee",
    accentSoft: "rgba(34,211,238,0.18)",
  },
  {
    slug: "prod",
    index: "07",
    name: "2TProd",
    kicker: { en: "PHOTOGRAPHY & VIDEO STUDIO", fr: "STUDIO PHOTO & VIDÉO" },
    tagline: {
      en: "Lights. Lipstick. Roll.",
      fr: "Lumière. Rouge à lèvres. Action.",
    },
    body: {
      en: "Creative photoshoots and film for people and brands — editorial, campaign, product, personal. Directed, lit, shot and cut under one roof.",
      fr: "Photoshoots créatifs et films pour les personnes et les marques — éditorial, campagne, produit, personnel. Réalisé, éclairé, tourné et monté sous un même toit.",
    },
    services: {
      en: ["Editorial Photography", "Brand Campaigns", "Product & E-com", "Music Videos", "Corporate Film", "Personal Portraits"],
      fr: ["Photo éditoriale", "Campagnes de marque", "Produit & E-com", "Clips musicaux", "Films corporate", "Portraits"],
    },
    logo: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/hi5lze5v_2TPROD-TR.webp",
    video: "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/ttl8qy6t_2TProd_Red_Photography_Video_S_Gemini_Omni_Flash_91578.mp4",
    image: "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxwaG90b2dyYXBoeSUyMHZpZGVvJTIwc3R1ZGlvJTIwc2V0dXAlMjBiZWhpbmQlMjBzY2VuZXN8ZW58MHx8fHwxNzg0MDM4MTIyfDA&ixlib=rb-4.1.0&q=85",
    accent: "#ef4444",
    accentSoft: "rgba(239,68,68,0.20)",
  },
];

export const MASTER_LOGO =
  "https://customer-assets.emergentagent.com/job_creative-divisions/artifacts/9azdauzy_2TPROD_STUDIOS-TR.webp";

export const CONTACT_IMAGE =
  "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxkYXJrJTIwcGhvdG8lMjBzdHVkaW8lMjBzZXR8ZW58MHx8fHwxNzg0MDM4MTIyfDA&ixlib=rb-4.1.0&q=85";
